import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { safe_get } from "../../../../report-visuals";
import { useStore } from "../../../../helpers";
import type { SourceListItem } from "../../tars-hooks/useSourceList";
import type { SourceNode } from "../sidebar/sources-types";
import {
    dataBankSourceForElectionLabel,
    partyNamesFromElectionData,
} from "./facet-data-bank-election-helpers";

export function useNormalizeElectionParties(
    electionLabel: string,
    sources: SourceListItem[] | undefined,
    nodes: Record<string, SourceNode>
) {
    const { flexiStore } = useStore();
    const resolved = useMemo(
        () => dataBankSourceForElectionLabel(sources, nodes, electionLabel),
        [sources, nodes, electionLabel]
    );

    return useQuery({
        queryKey: [
            "tars-normalize-election-parties",
            resolved?.fsdId ?? 0,
            resolved?.electionKey ?? "",
        ],
        enabled: resolved != null,
        retry: false,
        queryFn: async () => {
            if (!resolved) return [];
            await flexiStore.get_fsdata(resolved.fsdId);
            const path = safe_get(flexiStore.current_fsd?.r1, "election_results", "");
            if (!path || typeof path !== "string") return [];
            await flexiStore.load_s3_json_resource(
                "urn-fsd",
                path,
                "tars_normalize_election_parties"
            );
            const all = flexiStore.external_resource;
            if (all == null || typeof all !== "object" || Array.isArray(all)) return [];
            const election = (all as Record<string, unknown>)[resolved.electionKey];
            return partyNamesFromElectionData(election);
        },
    });
}
